<template>
    <div class="multi-select-filter">
        <div class="dropdown" ref="dropdown">
            <button
                class="btn border bg-white dropdown-toggle px-2 first-btn"
                type="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <span class="message-container"> {{ message }} </span>
            </button>
            <div class="dropdown-menu w-100" ref="dropdownElement">
                <div class="form-check select-all">
                    <label class="form-check-label ps-3">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            :checked="options.length === selectedItems.length"
                            @change.prevent="toggleAllSelected()"
                        />
                        Select All
                    </label>
                </div>
                <div class="select-divider"></div>
                <span class="dropdown-item ps-3" v-for="(item, index) in options" :key="item.value">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :id="`option${item.value}${index}`"
                                :value="item.value"
                                @change="updateSelectedItems(item.value, $event)"
                                :checked="selectedItems.includes(item.value)"
                            />
                            {{ item.name }}
                        </label>
                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<style scoped>
.select-divider {
    height: 0;
    margin: 0.25rem 0;
    overflow: hidden;
    border-top: 1px solid #e9ecef;
}
</style>

<script lang="ts" src="./VisitStatusMultiSelect.ts"></script>
